import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { initializeFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// --- BLINDAGEM HÍBRIDA DE AMBIENTE ---
const currentHost = window.location.hostname;

// Identifica se o código está rodando na nuvem (Produção ou Homologação)
const isCloud = 
  currentHost.includes("web.app") || 
  currentHost.includes("firebaseapp.com") || 
  currentHost.includes("realbeneficios.com.br");

// 🛡️ IDENTIFICADORES ESTRITOS DE DOMÍNIO (A NOVA BLINDAGEM)
const isStrictProduction = currentHost === "app.realbeneficios.com.br" || currentHost === "realbeneficios.com.br";
const isStrictHomolog = currentHost.includes("homolog");

// --- AUTO-CORREÇÃO DO PROJECT ID ---
// Se o .env global vazou no build e trouxe o prefixo 'demo-', nós o arrancamos à força na nuvem.
let activeProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "";

if (isCloud && activeProjectId.startsWith("demo-")) {
  activeProjectId = activeProjectId.replace("demo-", "");
  console.warn("🔧 [AUTO-CORREÇÃO] O prefixo 'demo-' vazou do build, mas a blindagem corrigiu a rota para a nuvem.");
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: activeProjectId,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// --- TRAVA DE SEGURANÇA: FAIL FAST ---
/** @type {string[]} */
const missingKeys = [];
Object.entries(firebaseConfig).forEach(([key, value]) => {
  if (!value || String(value).includes("undefined")) {
    missingKeys.push(key);
  }
});

if (missingKeys.length > 0) {
  console.error("🚨 ERRO CRÍTICO: Chaves de ambiente ausentes no Build!");
  throw new Error(`Firebase Initialization FAILED. Missing variables: ${missingKeys.join(", ")}`);
}

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// --- ROTEAMENTO MULTI-DB BLINDADO (A ÚLTIMA LINHA DE DEFESA) ---
// Tenta ler o .env padrão compilado no build
let targetDatabaseId = process.env.REACT_APP_FIREBASE_DATABASE_ID || "(default)";

// 🛡️ O DOMÍNIO MANDA, O .ENV OBEDECE
// Aqui corrigimos o vazamento: Se o domínio for a produção real, esmagamos qualquer erro do .env.
if (isStrictProduction) {
  targetDatabaseId = "(default)"; // Força Produção
} else if (isStrictHomolog) {
  targetDatabaseId = "homolog"; // Força Homologação
}

// O databaseId é o TERCEIRO parâmetro obrigatório da função, garantindo o isolamento absoluto!
export const db = initializeFirestore(
  app, 
  { experimentalForceLongPolling: true }, 
  targetDatabaseId 
);

export const storage = getStorage(app);

// Namespace lógico do bucket compartilhado.
// Deve permanecer coerente com o Firestore selecionado acima.
export const storageEnvironment =
  targetDatabaseId === "homolog" ? "homolog" : "production";

export const functions = getFunctions(app, "us-central1");

// --- CONTROLE DE EMULADORES ---
const envAsksForEmulator = process.env.REACT_APP_USE_EMULATOR === "true";
// Só usamos emulador se a flag for true E NÃO estivermos na nuvem
const useEmulators = envAsksForEmulator && !isCloud;

if (useEmulators) {
  console.log(`🚀 Real Benefícios [DEV Mode]: Conectando aos Emuladores no host: ${currentHost}...`);
  const emulatorHost = currentHost === "localhost" ? "127.0.0.1" : currentHost;
  
  connectAuthEmulator(auth, `http://${emulatorHost}:9099`);
  connectFirestoreEmulator(db, emulatorHost, 8080);
  connectFunctionsEmulator(functions, emulatorHost, 5001);
  connectStorageEmulator(storage, emulatorHost, 9199);
} else {
  console.log(`🌐 Real Benefícios [Cloud Mode]: Projeto (${activeProjectId}) | Banco: ${targetDatabaseId}`);
}